import { showErrorNotification, showSuccessNotification } from '@/utils/utils.js';
import { listToken, createToken, destroyToken } from '@goldcast/api/backend';

export default {
  async getAllTokens(context) {
    context.commit('setFetchTokenListLoading', true);
    context.commit('setFetchTokenListError', null);

    listToken()
      .then(tokens => {
        context.commit('setTokenList', tokens);
      })
      .catch(error => {
        context.commit('setFetchTokenListError', error);
        showErrorNotification("Error: Couldn't load tokens at the moment! Try again.");
      })
      .finally(() => {
        context.commit('setFetchTokenListLoading', false);
      });
  },

  async generateToken(context, tokenName) {
    context.commit('setCreateTokenLoading', true);
    context.commit('setCreateTokenError', null);

    createToken({
      body: {
        name: tokenName
      }
    })
      .then(newToken => {
        const currentTokenList = context.state.tokenList;
        const updatedTokenList = [newToken, ...currentTokenList];
        context.commit('setFlashToken', newToken);
        context.commit('setTokenList', updatedTokenList);
        showSuccessNotification('New token created successfully.');
      })
      .catch(error => {
        context.commit('setCreateTokenError', error);
        showErrorNotification("Error: Couldn't create new token at the moment! Try again.");
      })
      .finally(() => {
        context.commit('setCreateTokenLoading', false);
      });
  },

  async deleteToken(context, tokenID) {
    context.commit('setDeleteTokenLoading', true);
    context.commit('setDeleteTokenError', null);
    context.commit('setFlashToken', null);

    destroyToken({
      id: tokenID
    })
      .then(() => {
        const currentTokenList = context.state.tokenList;
        const updatedTokenList = currentTokenList.filter(tokenData => Number(tokenData.id) !== Number(tokenID));
        context.commit('setTokenList', updatedTokenList);
        showSuccessNotification('Token deleted successfully.');
      })
      .catch(error => {
        context.commit('setDeleteTokenError', error);
        showErrorNotification("Error: Couldn't delete token at the moment! Try again.");
      })
      .finally(() => {
        context.commit('setDeleteTokenLoading', false);
      });
  }
};
